import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient) {
    }

    public get(accountId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'customer/get?accountId=' + accountId).subscribe(data => {
                resolve(data);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }
}
